import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import JusttawkLogo from "../../../assets/Justtawk-01.png";
import JusttawkBg from "../../../assets/justtawk-bg.png";

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

export default function Qr() {
  const navigate = useNavigate();
  const callCenterNumber = localStorage.getItem("selectedPhone");

  const { width, height } = useWindowSize();

  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "white",
      }}
    >
      <Grid
        item
        xs={12}
        sm={4}
        md={4}
        sx={{
          width: "100%",
          backgroundImage: { xs: `url(${JusttawkBg})` },
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          color: "white",
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: "20px", md: "100px 0" },
        }}
      >
        <Typography
          sx={{
            fontWeight: { xs: 400, md: 900 },
            fontSize: { xs: "1.1rem", md: "1.8rem" },
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Welcome to{" "}
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              justifyContent: "center",
              alignItems: "center",
              p: "7px 0",
            }}
          >
            <img
              src={JusttawkLogo}
              alt="Justtawk Logo"
              style={{
                maxWidth: "220px",
                width: "100%",
                height: "auto",
              }}
            />
          </Box>
          <Box sx={{ display: { xs: "none", md: "inline" } }}>Justtawk</Box>
        </Typography>
        <Typography
          sx={{
            fontWeight: { xs: 400, md: 100 },
            fontSize: "1rem",
            textAlign: "center",
          }}
        >
          Your Gateway to Effortless Call Center.
        </Typography>
      </Grid>

      {/* Confetti */}
      {showConfetti && <Confetti width={width} height={height} />}

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          width: "100%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1.8rem", md: "3rem" },
            fontWeight: 900,
            lineHeight: { xs: "35px", md: "50px" },
            mb: 2,
          }}
          component="h1"
        >
          Congratulations! Your Call Center is ready
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            mb: 4,
            fontSize: { xs: "1rem", md: "1.4rem" },
            fontWeight: 100,
            color: { xs: "black", md: "grey" },
            lineHeight: { xs: "20px", md: "26px" },
          }}
        >
          Scan the QR code with your mobile to connect with your call center,
          <br />
          or dial the customer care number below.
        </Typography>

        {/* QR Code */}
        <QRCodeSVG value={callCenterNumber || ""} size={150} />

        {/* Phone Number */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            mt: 3,
            fontSize: { xs: "1.1rem", md: "1.5rem" },
          }}
        >
          Your Call Center number: <br />
          <a
            href={`tel:${callCenterNumber}`}
            style={{
              textDecoration: "none",
              color: "#1976d2",
              fontWeight: 900,
            }}
          >
            {callCenterNumber}
          </a>
        </Typography>

        {/* CTA */}
        <Button
          variant="contained"
          size="large"
          sx={{ mt: 3, textTransform: "capitalize" }}
          onClick={() => navigate("/dashboard")}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
}
